import React from 'react';
import {IngredientsTable, AddEditIngredient, Search, CounterPage} from '../../organisms'
import { useSelector, useDispatch } from 'react-redux'
import './Ingredients.css';
import { filtrSearchArr, sortCategory, sortName, sortArrDate } from '../../../utils/utils.js'
import { getIngPage } from '../../../store/api.js'

export function Ingredients(props) {
  const { ingredientsPage, statusPage, errorPage, count } = useSelector(state => state.ingredients)
  const { lib, statusLib } = useSelector(state => state.lib)  
  const limit = 20;
  const dispatch = useDispatch();
  const [inputTimer, setInputTimer] = React.useState(null);
  const [sort, setSort] = React.useState({});
  const [keyword, setKeyword] = React.useState('')  
  const [currentPage, setCurrentPage] = React.useState(1) 
  const [showModal, setShowModal] = React.useState(false) 
  const [showModalEdit, setShowModalEdit] = React.useState(false)
  const [editCard, setEditCard] = React.useState(false)
  const [copyCard, setCopyCard] = React.useState(false) 
  const allPages = Math.ceil(count/limit)
  const pages = Array.from({length: allPages}, (_, i) => i + 1)  
  const parametrSearch = {
    currentPage, 
    title: keyword, 
    limit: limit, 
  };
  console.log(lib, statusLib, showModalEdit)
  React.useEffect(()=> {  
    dispatch(getIngPage(parametrSearch)); 
  },[currentPage])

  React.useEffect(() => {
    if (currentPage) {
        clearTimeout(inputTimer);
        let timeout = setTimeout(() => { 
            parametrSearch.searchWords = keyword;
            dispatch(getIngPage(parametrSearch));
        }, 1000);
        setInputTimer(timeout);
    }
    return () => clearTimeout(inputTimer)
  }, [keyword]);


  function handleSortName() {
   
  }

  function handleSortCategory() {
    
  }

  function handleAddIngredient() {
    setShowModal(true)
  }

  function handleCloseModal() {
    setShowModal(false)
    setShowModalEdit(false)
    setEditCard(false)
    setCopyCard(false)
  }
 
  function handleEdit(card) {
    setShowModalEdit(true)
    setEditCard(card)
    setCopyCard(false)
  }

  function handleCopy(card) {
    setShowModalEdit(true)
    setEditCard(card)
    setCopyCard(true)
  }

    //Слушатель на ввод поисковых слов
    function handleChangeInput(e) {
      setCurrentPage(1)
      setKeyword(e.target.value)   
    }
  
   //Счетчик изменения страниц
  function handleCounter(page) { 
    setCurrentPage(page)
  }

  const toggleModal = () => { 
    setShowModal(false)
  
};


  return (
    <main className='content'>
      <Search onSearch={handleChangeInput} keyword={keyword}/>
      <button onClick={handleAddIngredient} className='my-recipe__add-button'>Добавить ингредиент</button>
      <table className='table'>
        <caption> Ингридиенты</caption>
        <thead className='table__thead'>
          <tr className='table__tr'>
            <th className='table__th'>Название<span className='gg-sort item__link' onClick={handleSortName}></span></th>
            <th className='table__th'>Категория<span className='gg-sort item__link' onClick={handleSortCategory}></span></th> 
            <th className='table__th'>Указать цену</th>
            <th className='table__th'>Редактировать</th>
          </tr>
        </thead>
      <tbody>
      {ingredientsPage &&
       ingredientsPage.map((ingredient)=> (
        <IngredientsTable 
          ingredient={ingredient} 
          key={ingredient._id}  
          editIngredient={handleEdit}
          copyIngredient={handleCopy} 
          lib={lib}
          />
       ))
     }
       </tbody>
      </table>
      <CounterPage handleCounter={handleCounter} pages={pages} currentPage={currentPage} totalCount={count}/>
 
        <AddEditIngredient 
          onClose={handleCloseModal} 
          onError={props.onError} 
          postIng={props.postIng} 
          isOpenEdit={showModalEdit} 
          isOpen={showModal} 
          card={editCard && editCard}
          copyCard={copyCard && copyCard}
          lib={lib}
        /> 
 
    </main>
  )
   
}